export const UserRoles = {
	CreditAnalyst: 'CreditAnalyst',
	AccountManager: 'AccountManager',
	SuperAdmin: 'SuperAdmin',
	SEOManager: 'SEOManager',
	Compliance: "Compliance"
};
